export default __webpack_public_path__ + "static/media/onePieceLogoTransparent.ea05a657.png";